<ng-container *ngIf="user">
  <img [src]="photoUrl">
  <div class="initials">
    {{initials}}
  </div>
</ng-container>
